import { stringify, parse } from 'flatted';
import * as CircularJSON from 'circular-json';
import { apiUrl } from '../config';

let FlattedApps = [];

if (apiUrl()=='https://ws.test.cxp.mgcs.gov.on.ca/on-form-service') FlattedApps = [];

export const stringifyJson = (json: any, app: string) => {
    if (!json || Object.keys(json).length === 0) {
        return '';
    }
    if (FlattedApps.includes(app.toLowerCase())) {
        return stringify(json);
    }
    return CircularJSON.stringify(json);
}

export const parseJson = (json: string, app: string) => {
    if (!json) {
        return null;
    }
    if (app && FlattedApps.includes(app.toLowerCase())) {
        return parse(json);
    }
    return CircularJSON.parse(json);
} 

  export const deepClone = <T>(obj: T, seen = new WeakMap()): T => {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    if (seen.has(obj as any)) {
      return seen.get(obj as any);
    }

    const clone: any = Array.isArray(obj) ? [] : {};
    seen.set(obj as any, clone);

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        clone[key] = deepClone((obj as any)[key], seen);
      }
    }

    return clone;
  }

  export const shallowClone = <T>(obj: T): T => {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    const clone: any = Array.isArray(obj) ? [] : {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
        clone[key] = (obj as any)[key]; // no recursion
        }
    }
    return clone;
};

  export const deleteAnyNode = (deleteKey,data, seen = new WeakMap()) => {

        if (data === null || typeof data !== 'object') {
            return data;
        }

        if (data instanceof Date) return new Date(data);
        if (data instanceof RegExp) return new RegExp(data);

        if (seen.has(data)) {
            return seen.get(data);
        }

        if (Array.isArray(data)) {
            const resultArr = [];
            seen.set(data, resultArr); 
            data.forEach(item => {
            resultArr.push(deleteAnyNode(deleteKey, item, seen));
            });
            return resultArr;
        }

        const resultObj = {};
        seen.set(data, resultObj); 

        Object.keys(data).forEach(key => {
            if (key !== deleteKey) {
            resultObj[key] = deleteAnyNode(deleteKey, data[key], seen);
            }
        });

        return resultObj;
    };

/**
 * Removes properties with empty values (null, undefined, or empty string) from an object.
 * Used to omit empty fields from API request payloads.
 * Recurses into plain objects; arrays and other types are left as-is.
 */
export const removeEmptyPayloadFields = <T extends Record<string, any>>(obj: T): Partial<T> => {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    if (Array.isArray(obj) || obj instanceof Date || obj instanceof RegExp) {
        return obj as any;
    }
    const result: Record<string, any> = {};
    for (const key of Object.keys(obj)) {
        const value = obj[key];
        if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) {
            continue; // omit empty fields
        }
        if (typeof value === 'object' && value !== null && !Array.isArray(value) && !(value instanceof Date)) {
            const cleaned = removeEmptyPayloadFields(value);
            if (Object.keys(cleaned as object).length > 0) {
                result[key] = cleaned;
            }
        } else {
            result[key] = value;
        }
    }
    return result as Partial<T>;
};
